import * as jsxRuntime from "/Users/marfil/Documents/proyectos/peskay/backoffice/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment